module.exports = __webpack_public_path__ + "img/1.b5420010.png";